import React from 'react';

import { Alert } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

import { useUserRecordingCapability } from '#src/app/pages/actions/shared/hooks';

import { CopylinkButton } from '../CopylinkButton';
import { OpenCameraButton } from '../OpenCameraButton';

export const AddYourVideoButton: React.FC = () => {
	const capability = useUserRecordingCapability();

	return (
		<>
			{capability === 'capable' && <OpenCameraButton />}

			{capability === 'unsupported-browser' && (
				<>
					<Alert
						variant="info"
						heading={
							<Translate value="corgi.petition_actions.supporter_voice_video.record.unsupported_browser.title" />
						}
					>
						<Translate value="corgi.petition_actions.supporter_voice_video.record.unsupported_browser.message" />
					</Alert>
					<CopylinkButton />
				</>
			)}
		</>
	);
};
